import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import DBApp from './db/DBApp';
import Triads from './triads/Triads';
import Production from './production/Production';
import MelodyApp from './midi/MelodyApp';
import MelODGen from './melody/MelODGen';
import GameOfLife from './gameOfLife/gameOfLife';
import Investing from './investing/investing';
import Comic from './comic/comic';
import EightBall from './8ball/8ball';
import UniversalSimulator from './universalSimulator/universalSimulator';
import ScoringEngine from './scoring/ScoringEngine';

function App() {

  const [ colorModeClass, setColorModeClass ] = useState('App-dark')
  const [ colorModeButtonLabel, setcolorModeButtonLabel ] = useState('Light Mode');
  const [ bodyColors, setBodyColors ] = useState({ 'background': '#000000', 'text': '#FFFFFF'});
  const [ menuSelection, setMenuSelection ] = useState('home');
  const [ subMenu, setSubMenu ] = useState('');
  const viewerWidth = window.innerWidth;
  const viewerHeight = window.innerHeight;
  const listeningChoices = [ 'Random', 'Album', 'Genre', 'Playlist' ];
  const [ listeningChoice, setListeningChoice ] = useState('Album');

  useEffect(() => { document.body.style.backgroundColor = bodyColors.background; }, [bodyColors]);
  useEffect(() => { document.body.style.color = bodyColors.text; }, [bodyColors]);

  const toggleColorMode = () => {
    if (colorModeClass === 'App-dark') {
      setcolorModeButtonLabel('Dark Mode');
      setColorModeClass('App-light');
      setBodyColors({ 'background': '#FFFFFF', 'text': '#000000'});
    } else {
      setcolorModeButtonLabel('Light Mode');
      setColorModeClass('App-dark');
      setBodyColors({ 'background': '#000000', 'text': '#FFFFFF'});
    }
  };

  const toggleSubMenu = (selection) => {
    if (subMenu === selection) {
      setSubMenu('');
    } else {
      setSubMenu(selection);
    }
  }

  const playListChoice = (choice) => {
    setMenuSelection('Music');
    setSubMenu('');
    setListeningChoice(listeningChoices[choice]);
  }

  return (
    <div className={colorModeClass}>
      <Router>
        <header className="App-header">
          <h5><Link className="menuItem" to="/"><b>Quietman Productions</b></Link></h5>
        </header>
        <div id="menu">
          <div className={ menuSelection === "Music" ? "selected" : "unselected"} onClick={() => toggleSubMenu('Music')}>
            Music
            {(subMenu === 'Music') && <div className="subMenu">
              <ul>
                <li>Recordings</li> 
                <ul>
                  {listeningChoices.map((list, index) => <li key={index + 1} onClick={() => playListChoice(index)}><Link className="menuItem" to="/musicplayer">{list}</Link></li>)}
                </ul>
                <li><Link className="menuItem" to="/triads">Triads</Link></li>
                <li><Link className="menuItem" to="/production">Production</Link></li>
                <li><Link className="menuItem" to="/melodygenerator">Melody Generator</Link></li>
                <li><Link className="menuItem" to="/MelODGen">Melody Generator 2</Link></li>
                <li><Link className="menuItem" to="/eightball">Eight Ball</Link></li>
                <li><Link className="menuItem" to="/scoringengine">Scoring Engine</Link></li>
              </ul>
            </div>}
          </div>
          <div className={ menuSelection === "Stories" ? "selected" : "unselected"} onClick={() => toggleSubMenu('Stories')}>
            Stories
            {(subMenu === 'Stories') && <div className="subMenu">
              <ul>
                <li><Link className="menuItem" to="/storyboard">Story Board</Link></li>
                <li><Link className="menuItem" to="/universalsimulator">Universal Simulator</Link></li>
                <li><Link className="menuItem" to="/investing">Investment Strategy</Link></li>
              </ul>
            </div>}
          </div>
          <div className={ menuSelection === "Games" ? "selected" : "unselected"} onClick={() => toggleSubMenu('Games')}>
            Games
            {(subMenu === 'Games') && <div className="subMenu">
              <ul>
                <li><Link className="menuItem" to="/bellbox">Bell Box Game</Link></li>
                <li><Link className="menuItem" to="/gameoflife">Game of Life</Link></li>
                <li><Link className="menuItem" to="/explorer">Explorer Game</Link></li>
              </ul>
            </div>}
          </div>
        </div>
        <Routes>
          {/* React Router decides which component to show based on the URL */}
          <Route path="/" element={<div id="home"><h1>A place for some of Paul's stuff.</h1></div>} />
          <Route path="/musicplayer" element={<DBApp {...{listeningChoice}} />} />
          <Route path="/production" element={<Production />} />
          <Route path="/triads" element={<Triads />} />
          <Route path="/melodygenerator" element={<MelodyApp {...{colorModeClass}} />} />
          <Route path="/MelODGen" element={<MelODGen {...{colorModeClass}} />} />
          <Route path="/eightball" element={<EightBall />} />
          <Route path="/scoringengine" element={<ScoringEngine />} />
          <Route path="/storyboard" element={<Comic {...{viewerWidth, viewerHeight}}/>} />
          <Route path="/universalsimulator" element={<UniversalSimulator />} />
          <Route path="/investing" element={<Investing />} />
          <Route path="/bellbox" element={<iframe id="bellBoxGame" src=".\games\bell_box\bell_box.html" title="Bell Box Game"></iframe>} />
          <Route path="/gameoflife" element={<GameOfLife {...{viewerWidth, viewerHeight}} />} />
          <Route path="/explorer" element={<iframe id="explorerGame" src="/games/explorer/index.html" title="Explorer Game"></iframe>} />
        </Routes>
      </Router>
      <button id="color-mode-toggle" onClick={toggleColorMode}>{colorModeButtonLabel}</button>
    </div>
  );
}

export default App;
